import $ from 'jquery'
import SearchReport from '../sections/report-search'

onDomLoad(function ($dom) {
  $dom.find("[data-behaviour='search-report-input']").each((_idx, el) => {
    const $reportList = $("[data-behaviour='search-report-list']")
    const $emptyList = $("[data-behaviour='search-report-empty-state']")
    const $input = $(el)

    new SearchReport($input, $reportList, $emptyList)
  })
})
